<div class="search-wrapper">
  <div class="search-form">
    <input
      type="text"
      class="contact-search"
      placeholder="Add existing contact"
      [formControl]="searchInput"
      (focus)="isFocus(true)"
      (blur)="isFocus(false)"
    />
    <div class="search-icon">
      <img src="assets/Keen&Wise_search_dark.png" />
    </div>
  </div>
  <ul class="search-results" *ngIf="searchInputFocus">
    <li
      class="search-result"
      *ngFor="let searchResult of searchResults"
      (click)="onSelectResult(searchResult)"
    >
      <span>{{ searchResult.name }}&nbsp;-&nbsp;</span
      ><strong>{{ searchResult.personType }}</strong>
    </li>
    <li class="search-result" (click)="onAddNewContact()">
      <div class="search-result-img">
        <img src="assets/Keen&Wise_add_photo_transparant.png" />
      </div>
      <span class="create-new-txt">Create new contact</span>
    </li>
  </ul>
</div>
